import { useState } from "react";
import { ServiceRequestsIcon } from "../../../../../assets/icons";
import UtilityPageLayout from "../../../component/layout/UtilityPageLayout";
import styles from "./PaymentOptionPage.module.scss";
import Button from "../../../../../common/components/xepp/button/Button";
import { useNavigate } from "react-router-dom";
import PaymentAmountForm from "../components/PaymentAmountForm/PaymentAmountForm";
import PaymentOverviewModal from "../components/PaymentOverviewModal/PaymentOverviewModal";
import { useDispatch, useSelector } from "react-redux";
import { resetAllOptionAmounts, setAmount, setIsPaymentPerSubtype, setPaymentRequired, setIsPayOnSubmit } from "../../../../../stores/slices/service-type-slice";
import { RootState } from "../../../../../stores/store";
import { toast } from "react-toastify";

const PaymentOptionPage = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const currentState = useSelector((state: RootState) => state.serviceType);

	const [selectedPayment, setSelectedPayment] = useState<boolean>(currentState.isPaymentRequired);
	const [isPayOnSubmit, setPayOnSubmit] = useState<boolean | undefined>(currentState.payOnSubmit);
	const [showPaymentOverviewModal, setShowPaymentOverviewModal] = useState(false);

	const handlePaymentChange = (value: boolean) => {
		dispatch(setPaymentRequired(value));
		dispatch(setAmount(undefined));
		if (!value) {
			dispatch(setIsPaymentPerSubtype(value));
			dispatch(resetAllOptionAmounts());
		}

		setSelectedPayment(value);
	};
	const handlePayOnSubmitChange = (value: boolean) => {
		dispatch(setIsPayOnSubmit(value));
		setPayOnSubmit(value);
	};

	const onContinueClick = () => {
		if (selectedPayment && isPayOnSubmit === undefined) {
			toast.warning("Please select when the payment should be collected");
			return;
		} else {
			setShowPaymentOverviewModal(true);
		}
	};

	const onCancelClick = () => {
		navigator(-1);
	};

	return (
		<UtilityPageLayout title="Payment">
			{showPaymentOverviewModal && <PaymentOverviewModal onModalClose={() => setShowPaymentOverviewModal(false)} />}
			<div className={styles.contentContainer}>
				<div className={styles.headerWrapper}>
					<div className={styles.iconContainer}>{<ServiceRequestsIcon />}</div>
					<h3>Add Payment</h3>
				</div>
				<div className={styles.bodyWrapper}>
					<div className={styles.bodyContainer}>
						<div className={styles.paymentRequiredRow}>
							<div className={styles.paymentRequiredLabelContainer}>
								<label>Payment Required</label>
							</div>
							<div className={`${styles.radioButtonWrapper} ${styles.yesRadio}`}>
								<div className={styles.radioButtonContainer} onClick={() => handlePaymentChange(true)}>
									<input type="radio" id="trueOption" name="booleanGroup" checked={selectedPayment === true} onChange={() => handlePaymentChange(true)} />
									<label htmlFor="trueOption">Yes</label>
								</div>
							</div>

							<div className={`${styles.radioButtonWrapper} ${styles.noRadio}`}>
								<div className={styles.radioButtonContainer} onClick={() => handlePaymentChange(false)}>
									<input type="radio" id="falseOption" name="booleanGroup" checked={selectedPayment === false} onChange={() => handlePaymentChange(false)} />
									<label htmlFor="falseOption">No</label>
								</div>
							</div>
						</div>
						{selectedPayment && (
							<>
								<PaymentAmountForm />
								<div className={styles.paymentRequiredRow}>
									<div className={styles.paymentRequiredLabelContainer}>
										<label>When should the payment be collected?</label>
									</div>
									<div className={`${styles.radioButtonWrapper} ${styles.yesRadio}`}>
										<div className={styles.radioButtonContainer} onClick={() => handlePayOnSubmitChange(true)}>
											<input
												type="radio"
												id="PayOnSubmitTrueOption"
												name="payOnSubmitBooleanGroup"
												checked={isPayOnSubmit === true}
												onChange={() => handlePayOnSubmitChange(true)}
											/>
											<label htmlFor="PayOnSubmitTrueOption">When user submit service request</label>
										</div>
									</div>

									<div className={`${styles.radioButtonWrapper} ${styles.noRadio}`}>
										<div className={styles.radioButtonContainer} onClick={() => handlePayOnSubmitChange(false)}>
											<input
												type="radio"
												id="PayOnSubmitFalseOption"
												name="payOnSubmitBooleanGroup"
												checked={isPayOnSubmit === false}
												onChange={() => handlePayOnSubmitChange(false)}
											/>
											<label htmlFor="PayOnSubmitFalseOption">Payment determined on workflow</label>
										</div>
									</div>
								</div>
							</>
						)}
						<div className={styles.footerWrapper}>
							<Button text={"Cancel Setup"} onClick={onCancelClick} variant={"outline"} />
							<Button text={"Continue"} onClick={onContinueClick} variant={"secondary"} />
						</div>
					</div>
				</div>
			</div>
		</UtilityPageLayout>
	);
};

export default PaymentOptionPage;
